// extracted by mini-css-extract-plugin
module.exports = {"btnLoading":"btn-module__btnLoading"};